import vimiumChromePlugin from "../../../../src/images/util/vimium_chrome_plugin.png";
import vimiumFirefoxPlugin from "../../../../src/images/util/vimium_firefox_plugin.png";
import vimiumMacAppStore from "../../../../src/images/util/vimari_mac_appstore.png";
import vimiumHelp from "../../../../src/images/util/vimium_help.png";
import vimiumFf from "../../../../src/images/util/vimium_fF.png";
import * as React from 'react';
export default {
  vimiumChromePlugin,
  vimiumFirefoxPlugin,
  vimiumMacAppStore,
  vimiumHelp,
  vimiumFf,
  React
};